module.exports = __webpack_public_path__ + "img/media_3.0e33c9e6.jpg";